import React from "react";
import PropTypes from "prop-types";
import Calendar from "./calendar.js";
import { toDateString } from "../utils/formatting";

const MIN_DATE_NAISSANCE = new Date("1900-01-01 00:00:00.000");

export default function ProfileDateInput({
  label,
  profile,
  setProfileState,
  error,
  calIconDansChamp,
  showCalendrierDateNaissance,
  toggleCalendrierDateNaissance,
  onSelectDateNaissance,
  calendarDateNaissanceWrapperDivRef,
}) {
  const dateDisplay = (profile.dateNaissance || "").substring(0, 10);

  const calendarPopover = showCalendrierDateNaissance && (
    <div
      className="calendar-wrapper"
      ref={calendarDateNaissanceWrapperDivRef}
      tabIndex={0}
      onBlur={e => {
        // Désactivé. Est incomptable avec Calendar.props.allowChangeYear.
        /*if (!this.state.isCalendarBlurred)
          this.setState({ showCalendrierDateNaissance: false })
        else
          this.setState({ isCalendarBlurred: false });*/
      }}
    >
      <Calendar
        onDayClick={date => {
          if (date < MIN_DATE_NAISSANCE || date > new Date()) return;

          onSelectDateNaissance(toDateString(date));
        }}
        initialMonth={profile.dateNaissance || new Date()}
        minDate={MIN_DATE_NAISSANCE}
        maxDate={new Date()}
        allowChangeYear={true}
      />
    </div>
  );

  return (
    <div className={"profile-div" + (calIconDansChamp ? "" : " profile-date-field-outside-icon")}>
      <div className="profile-div profile-label-wrapper">
        <span className="profile-span">{label}</span>
      </div>
      <div className="profile-div input-container">
        {calIconDansChamp ? (
          <div className="profile-date-input-wrap">
            <input
              type="text"
              value={dateDisplay}
              onChange={e => setProfileState({ ...profile, dateNaissance: e.target.value })}
              readOnly={true}
              className="profile-input clickable profile-date-input-field"
              onMouseDown={e => toggleCalendrierDateNaissance()}
            />
            <img
              src={require("../../images/icons/calendar-2.png")}
              alt="calendrier"
              onMouseDown={e => toggleCalendrierDateNaissance()}
              className="profile-img profile-date-input-calendar-btn clickable"
            />
            {calendarPopover}
          </div>
        ) : (
          <>
            <input
              type="text"
              value={dateDisplay}
              onChange={e => setProfileState({ ...profile, dateNaissance: e.target.value })}
              readOnly={true}
              className="profile-input clickable"
              onMouseDown={e => toggleCalendrierDateNaissance()}
            />
            {calendarPopover}
          </>
        )}
        {error && <span className="color-error profile-span">{error}</span>}
      </div>
      {!calIconDansChamp && (
        <img
          src={require("../../images/icons/calendar-2.png")}
          alt="calendrier"
          onMouseDown={e => toggleCalendrierDateNaissance()}
          className="profile-img"
        />
      )}
    </div>
  );
}

ProfileDateInput.propTypes = {
  label: PropTypes.node.isRequired,
  profile: PropTypes.object.isRequired,
  setProfileState: PropTypes.func.isRequired,
  error: PropTypes.node,
  calIconDansChamp: PropTypes.bool,
  showCalendrierDateNaissance: PropTypes.bool.isRequired,
  toggleCalendrierDateNaissance: PropTypes.func.isRequired,
  onSelectDateNaissance: PropTypes.func.isRequired,
  calendarDateNaissanceWrapperDivRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};
